import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import DesignationCustomRequisitionsModal from './DesignationCustomRequisitionsModal';

class DesignationCustomRequisitionComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal_props: false,
      designation_id: this.props.designation_id,
      designation_requisition: this.props.designation_requisition,
    };
    //bind específico
    this.editRequisition = this.editRequisition.bind(this);
    this.closeModalParent = this.closeModalParent.bind(this);

    // Handlers
    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({designation_id: newProps.designation_id});
    this.setState({designation_requisition: newProps.designation_requisition});
  }
  
  editRequisition () {
    this.setState({modal_props: true});
  }

  closeModalParent() {
    this.setState({modal_props: false});
  }


  render() {
    var self = this;
    return (
<div>
    <table className="table">
      <thead>
        <tr>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tabela.Nome}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tabela.Tipo}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tabela.LimiteDeHoras}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tabela.DiasCorridos}
          </th>
          <th>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="requisicoes">
        <tr>
          <td width='150'>
            {self.state.designation_requisition.name}
          </td>
          <td width='150'>
            {self.state.designation_requisition.type_str}
          </td>
          <td width='100'>
            {self.state.designation_requisition.hours_limit}
          </td>
          <td width='100'>
            {self.state.designation_requisition.days}
          </td>
          <td width='150'>
            <button className="btn btn-sm btn-primary" value={self.state.designation_requisition.id} onClick={self.editRequisition}>
              <i className="fa fa-fw fa-pencil"></i>
            </button>
            <button className="btn btn-sm btn-danger"  onClick={() => self.props.deleteRequisiton(self.state.designation_requisition.id)}>
              <i className="fa fa-fw fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <DesignationCustomRequisitionsModal handleAlert={self.props.handleAlert} loadData={self.props.loadData} closeModalParent={self.closeModalParent} RequestApi={self.props.RequestApi} designation_requisition={self.state.designation_requisition} designation_requisition_id={self.state.designation_requisition.id} modal_props={self.state.modal_props}/>
</div>
    );
  }
}

export default DesignationCustomRequisitionComponent;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationCustomRequisitionComponent.js